module.exports = __webpack_public_path__ + "fonts/SambhotaUnicodeweb.woff2";